import React from 'react'
import Helmet from 'react-helmet'
import {
  Box,
  Chip,
  Container,
  Grid,
  Typography,
  makeStyles,
  Divider,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  page: {
    background: `linear-gradient(180deg, ${theme.palette.cream.main} 0%, ${theme.palette.gray.light} 100%)`,
    minHeight: '100vh',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(8),
  },
  hero: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  badge: {
    display: 'inline-block',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: '#ddd',
    color: theme.palette.blue.main,
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.black.main,
  },
  subtitle: {
    maxWidth: 760,
    margin: '0 auto',
    color: theme.palette.gray.main,
    lineHeight: 1.7,
  },
  chipsRow: {
    marginTop: theme.spacing(3),
    justifyContent: 'center',
  },
  chip: {
    margin: theme.spacing(0.5),
    fontWeight: 600,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.black.main,
  },
  formWrapper: {
    padding: 0,
    margin: 0,
  },
  iframe: {
    display: 'block',
    width: '100%',
    height: 1200,
    border: 0,
  },
  sectionTitle: {
    color: theme.palette.black.main,
    fontWeight: 700,
  },
  sectionSubtitle: {
    color: theme.palette.gray.main,
  },
}))

export const TaxiboxPage = () => {
  const classes = useStyles()

  return (
    <>
      <Helmet>
        <title>TAXIBOX Partner Quote | Dogtainers</title>
        <meta
          name="description"
          content="Dogtainers quote form for customers referred by TAXIBOX."
        />
      </Helmet>

      <Box className={classes.page}>
        <Container maxWidth="md">
          <Box className={classes.hero}>
            <Box className={classes.badge}>TAXIBOX Partner Page</Box>

            <Typography variant="h3" component="h1" className={classes.title}>
              Pet transport made simple
            </Typography>

            <Typography variant="body1" className={classes.subtitle}>
              Thank you for coming to us from our trusted partners TAXIBOX.
              Please fill out the form below so that we can assist you with the
              move of your beloved animals.
            </Typography>

            <Grid container className={classes.chipsRow}>
              <Chip label="Experienced team" className={classes.chip} />
              <Chip label="Trusted pet transport" className={classes.chip} />
              <Chip label="Fast quote request" className={classes.chip} />
            </Grid>
          </Box>
          <hr/>

                <iframe
                  src="https://www.dogtainers.com.au/quote/?referrer=405dd26d-fb10-4335-bc75-d79481e8bf89"
                  id="dt-form"
                  title="Dogtainers Quote Form"
                  className={classes.iframe}
                />
            <div/>
        </Container>
      </Box>
    </>
  )
}